import {ActionTypes, ALERT, BACKDROP, CLOSEDTAB, SNACKBAR} from './actions'
import {CompnentInitialStateModel} from './model'

const initialState: CompnentInitialStateModel = {
  alert: {
    show: null,
    message: null,
    type: null,
  },
  backdrop: {
    show: null,
  },
  snackbar: {
    show: null,
    message: null,
    contractId: null,
    productCode: null,
  },
  closedTab: {
    tab: null,
    formName: null,
  },
}

export const actions = {
  writeAlert: (alert: ALERT) => ({type: 'WRITEALERT', payload: alert}),
  showBackdrop: (show: BACKDROP) => ({type: 'SHOWBACKFROP', payload: show}),
  showSnackbar: (show: SNACKBAR) => ({type: 'SHOWSNACKBAR', payload: show}),
  closeTab: (tab: CLOSEDTAB) => ({type: 'CLOSETAB', payload: tab}),
}

export const componentReducer = (state = initialState, action: ActionTypes) => {
  switch (action.type) {
    case 'WRITEALERT':
      const alertState = JSON.parse(JSON.stringify(state))
      alertState.alert.show = action.payload.show
      alertState.alert.message = action.payload.message
      alertState.alert.type = action.payload.type
      return alertState
    case 'SHOWBACKFROP':
      const backdropState = JSON.parse(JSON.stringify(state))
      backdropState.backdrop.show = action.payload.show
      return backdropState
    case 'SHOWSNACKBAR':
      const snackbarState = JSON.parse(JSON.stringify(state))
      snackbarState.snackbar.show = action.payload.show
      snackbarState.snackbar.message = action.payload.message
      snackbarState.snackbar.contractId = action.payload.contractId
      snackbarState.snackbar.productCode = action.payload.productCode
      return snackbarState
    case 'CLOSETAB':
      const closeTabState = JSON.parse(JSON.stringify(state))
      closeTabState.closedTab.tab = action.payload.tab
      closeTabState.closedTab.formName = action.payload.formName
      return closeTabState
    default:
      return state
  }
}
